import { useNavigate } from 'react-router-dom'
import { Sparkles } from 'lucide-react'
import { useI18n } from '../i18n/useI18n'

/**
 * #1870 ゲストで参加している人に、アカウントへの切り替えを促す。
 *
 * **引き継ぎ (#1876) だけでは使われない。** ログインさえすればスタンプは
 * 引き継がれるが、ゲストのまま回っている人に「アカウントにしませんか」と
 * 言う場所が無ければ、その仕組みは誰にも届かない。
 *
 * **完走した瞬間がいちばんの切り替えどころ。** 「あと 1 タップで抽選に参加
 * できます」と出せば、動機が最も高い場面で登録してもらえる。完走前は
 * 邪魔にならない文言に落とす。
 *
 * 抽選を設定していないイベントでは出さない — 見返りが無いのに登録を勧めるのは
 * ただの押し売りで、当日の体験を悪くする。
 */
export default function GuestUpgradeCard({
  /** 完走しているか。文言と強さを変える */
  completed,
  /** ログイン後に戻す場所 */
  redirectTo,
}: {
  completed: boolean
  redirectTo: string
}) {
  const { t } = useI18n()
  const navigate = useNavigate()

  return (
    <div
      className={`rounded-2xl px-4 py-4 shadow-card ${
        completed ? 'bg-yokoso-red/5 border border-yokoso-red/30' : 'bg-white'
      }`}
    >
      <div className="flex items-start gap-2">
        <Sparkles
          size={18}
          className={`mt-0.5 shrink-0 ${completed ? 'text-yokoso-red' : 'text-text-tertiary'}`}
        />
        <div className="min-w-0">
          <p className="font-display text-sm font-semibold text-text-primary">
            {completed ? t('stampRally.guestUpgradeDoneTitle') : t('stampRally.guestUpgradeTitle')}
          </p>
          <p className="mt-0.5 font-body text-xs text-text-secondary leading-relaxed">
            {t('stampRally.guestUpgradeNote')}
          </p>
        </div>
      </div>
      <button
        onClick={() => {
          // 引き継ぎ (#1876) はログイン時に走るので、ここは戻り先を覚えるだけでよい
          sessionStorage.setItem('postLoginRedirect', redirectTo)
          navigate('/login')
        }}
        className={`tap-effect mt-3 h-11 w-full rounded-xl font-display text-sm font-semibold text-white ${
          completed ? 'bg-yokoso-red' : 'bg-navy'
        }`}
      >
        {t('stampRally.guestUpgradeCta')}
      </button>
    </div>
  )
}
